<template>
  <div>
    <div class="fast-modal-content">
      <Teleport to="#fast-title">Quel est votre lieu de résidence&nbsp;?</Teleport>

      <div class="row">
        <StepRegistrationCountrySelect
          :grid-class="'col-12 col-sm-8'"
          :value="countryCode"
          @attributeChange="handleAttributeChange('countryCode', $event)"
        />
        <StepRegistrationInput
          :label="'Code postal'"
          :grid-class="'col-12 col-sm-4'"
          name="zip_code"
          autocomplete="postal-code"
          :value="zipCode"
          @attributeChange="handleAttributeChange('zipCode', $event)"
        />
      </div>
    </div>
    <StepsNavigation :next-step-disabled="!isValid" @prevStep="handlePrevStep" @nextStep="handleNextStep" />
  </div>
</template>

<script>
import { postcodeValidator, postcodeValidatorExistsForCountry } from 'postcode-validator'
import stepEvents from '../mixins/stepEvents'
import StepRegistrationCountrySelect from './StepRegistrationCountrySelect.vue'
import StepRegistrationInput from './StepRegistrationInput.vue'
import StepsNavigation from './StepsNavigation.vue'

export default {
  name: 'StepRegistrationLocation',
  components: {
    StepRegistrationCountrySelect,
    StepRegistrationInput,
    StepsNavigation
  },
  mixins: [stepEvents],
  props: {
    countryCode: {
      type: String,
      required: true
    },
    zipCode: {
      type: String,
      required: true
    }
  },
  computed: {
    zipCodeValid() {
      if (postcodeValidatorExistsForCountry(this.countryCode)) {
        return postcodeValidator(this.zipCode, this.countryCode)
      } else {
        return this.zipCode.length >= 3 && this.zipCode.length <= 20
      }
    },
    isValid() {
      return this.countryCode.length === 2 && this.zipCodeValid
    }
  },
  methods: {
    handleAttributeChange(param, value) {
      this.$emit('attributeChange', param, value)
    }
  }
}
</script>
